function getYoutubeEmbedUrl(url) {
  var regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
  var match = url.match(regExp);

  if (match && match[2].length === 11) {
    return 'https://www.youtube.com/embed/' + match[2] + '?autoplay=1&rel=0';
  } else {
    return url;
  }
}

document.addEventListener('DOMContentLoaded', function() {
  var videoLinks = document.querySelectorAll('.video-partners__play-button[data-lity]');

  videoLinks.forEach(function(link) {
    link.addEventListener('click', function() {
      var originalUrl = this.getAttribute('href');
      var embedUrl = getYoutubeEmbedUrl(originalUrl);

      this.setAttribute('href', embedUrl);
    });
  });
});
